import React, { useState } from "react";
import { isEmpty } from "lodash";
import cx from "classnames";
import Input from "../../components/input/Input";
import Button, { BUTTON_TYPES } from "../../components/button/Button";
import { ICONS } from "../../constants/icons.constants";
import { ERROR_FIELDS } from "../../pages/login/login.constants";
import { validateEmptyField } from "../../helpers/generel.helpers";
import { checkIfCanMove } from "../../pages/login/login.helpers";
import { doLogin } from "../../actions/user.actions";
import userStore from "../../zustand/user.store";
import logo from "../../logo.png";
import styles from "./MobileLogin.module.scss";

const MobileLogin = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [apiError, setApiError] = useState("");

  const { setIsAuthenticated } = userStore((state) => ({
    setIsAuthenticated: state.setIsAuthenticated,
  }));

  const handleLoginClick = async () => {
    const { errors, canMove } = checkIfCanMove(username, password);
    if (!canMove) {
      setError(errors);
      return;
    }
    setIsLoading(true);
    const isSuccess = await doLogin(username, password);
    if (!isSuccess) {
      setApiError("Invalid username or password");
      setIsLoading(false);
      return;
    }
    setIsAuthenticated(true);
  };

  return (
    <div className={styles.page}>
      <div className={styles.form}>
        <div className={styles.logoWrap}>
          <img src={logo} alt="4Play" className={styles.logo} />
          <p className={styles.subtitle}>To Continue login to For Play</p>
        </div>

        <div className={styles.inputs}>
          <Input
            placeholder="Username"
            value={username}
            setValue={setUsername}
            error={error}
            setError={setError}
            id={ERROR_FIELDS.USER_NAME}
            validator={validateEmptyField}
            type="text"
          />
          <div className={styles.inputGap}>
            <Input
              placeholder="Password"
              icon1={ICONS.EYE_ON}
              icon2={ICONS.EYE_OFF}
              value={password}
              setValue={setPassword}
              error={error}
              setError={setError}
              id={ERROR_FIELDS.PASSWORD}
              validator={validateEmptyField}
              type="password"
              hasToggleIcon
            />
          </div>
          {!isEmpty(apiError) && (
            <p className={styles.errorText}>{apiError}</p>
          )}
          <a
            href="https://4-play.io/forgotpass/"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.forgot}
          >
            Forgot ?
          </a>
        </div>

        <div className={styles.btnWrap}>
          <Button
            id="login_button_mobile"
            onClick={handleLoginClick}
            type={BUTTON_TYPES.PRIMARY}
            isLoading={isLoading}
          >
            Login
          </Button>
        </div>
      </div>
    </div>
  );
};

export default MobileLogin;
